export const selectUser = (state) => ({
  isAuth: state.user.isAuth,
  country: state.user.country,
  currency: state.user.currency,
  language: state.user.language,
});